import { render, staticRenderFns } from "./BussinessClassification.vue?vue&type=template&id=68db399e&scoped=true"
import script from "./BussinessClassification.vue?vue&type=script&lang=js"
export * from "./BussinessClassification.vue?vue&type=script&lang=js"
import style0 from "./BussinessClassification.vue?vue&type=style&index=0&id=68db399e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68db399e",
  null
  
)

export default component.exports